var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative w-full h-6 rounded-full border mt-1",style:({ borderColor: this.color })},[_c('div',{staticClass:"z-0 absolute h-full rounded-full",style:(_vm.barWidthAndColor)})])}
var staticRenderFns = []

export { render, staticRenderFns }